import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faCreditCardAlt,
  faRightFromBracket,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../config";
import { useInvoiceContext, usePagSeguroContext } from "../context";
import showError from "./ModalError";
import OptionsYearsUntilExpiration from "./OptionsYearsUntilExpiration";
import OptionsInstallments from "./OptionsInstallments";
import InputMask from "react-input-mask";
import ButtonNext from "./ButtonNext";
import { cnpValidation } from "../utils/cnpValidation";
import Lottie from "lottie-react";
import animationPayed from "../assets/payed_animation.json";
import animationLate from "../assets/clock_animation.json";
import { getCardBrand } from "../utils";
import { STATUS_ERROR, PAY_CREDIT_CARD, STATUS_PAID } from "../helpers";
import Confetti from "react-confetti";

const ModalPayWithCreditCard = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSended, setIsSended] = useState(false);
  const [isPayed, setIsPayed] = useState(false);
  const [isProcessedWithError, setIsProcessedWithError] = useState(false);
  const [errorString, setErrorString] = useState("");
  const [count, setCount] = useState(0);
  const [isLate, setIsLate] = useState(false);

  const {
    invoice,
    invoiceID,
    getInvoiceValue,
    setPGCardToken,
    setPGCardSenderHash,
    setPGCardInstallmentsQuantity,
    setPGCardInstallmentsValue,
    setPGCardOwnerName,
    setPGCardOwnerCPF,
    setPGCardOwnerBirthDate,
    setPGCardOwnerPhone,
    setInvoiceID,
    getCreditCardOwnerData,
    getInstallmentsQuantity,
    paymentMethod
  } = useInvoiceContext();

  const {
    creditCardNumber,
    setCreditCardNumber,
    creditCardCVV,
    setCreditCardCVV,
    creditCardExpirationMonth,
    setCreditCardExpirationMonth,
    creditCardExpirationYear,
    setCreditCardExpirationYear,
    installmentsArr,
    setInstallmentsArr,
    setIsLoadingInstallments,
    pagSeguroDirectPaymentInstance,
    pgReady,
    setPgReady,
    creditCardBrand,
    setCreditCardBrand,
  } = usePagSeguroContext();

  const handleCardNumber = (number) => {
    try {
      const cardNumber = number.replace(/\D/g, "");
      setCreditCardNumber(cardNumber);

      if (cardNumber.length >= 6) {
        setIsLoadingInstallments(true);
        let brand = getCardBrand(cardNumber);
        setCreditCardBrand(brand);
        var amount = parseFloat(getInvoiceValue()).toFixed(2);
        var shippingCoast = parseFloat(0);
        var max_installment_no_extra_fees = 3;
        const hasDiscount = parseFloat(invoice.invoice.general_info.valor_desconto) > 0;  

        pagSeguroDirectPaymentInstance.getInstallments({
          amount: amount + shippingCoast,
          brand: brand,
          maxInstallmentNoInterest: max_installment_no_extra_fees,
          success: function (response) {
            console.log(response);
            let installments = response.installments[brand];
            
            // Filtra as parcelas para mostrar apenas 1 quando há desconto
            if (hasDiscount) {
              installments = installments.filter(installment => installment.quantity === 1);
            }
  
            setInstallmentsArr(installments);
          },
          error: function (response) {
            console.log(response);
          },
          complete: function (response) {
            console.log(response);
            setIsLoadingInstallments(false);
          },
        });
      }
    } catch (error) {
      console.error("Error :", error);
    }
  };

  const createCardToken = () => {
    return new Promise((resolve, reject) => {
      pagSeguroDirectPaymentInstance.createCardToken({
        cardNumber: creditCardNumber,
        brand: creditCardBrand,
        cvv: creditCardCVV,
        expirationMonth: creditCardExpirationMonth,
        expirationYear: creditCardExpirationYear,
        success: function (json) {
          console.log(json);
          resolve(json);
        },
        error: function (json) {
          console.log(json);
          reject(json);
        },
        complete: function (json) {
          console.log(json);
        },
      });
    });
  };

  const sendPayment = (event) => {
    try {
      setPGCardSenderHash("");
      event.preventDefault();
      setIsLoading(!isLoading);
      createCardToken()
        .then((card) => {
          setPGCardToken(card.card.token);
          setPGCardSenderHash(pagSeguroDirectPaymentInstance.getSenderHash());
        })
        .catch((error) => {
          console.error("Error:", error);
          setIsLoading(false);
          showError(error);
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const dinamicCelMask = (value) => {
    if (value.length < 11) {
      return "(99) 9999-99999";
    } else {
      return "(99) 9 9999-9999";
    }
  };

  const canDoPayment = () => {
    // Preenchimento
    if (creditCardNumber.length < 16) return false;
    if (getInstallmentsQuantity <= 0) return false;
    if (creditCardExpirationMonth === "") return false;
    if (creditCardExpirationYear === "") return false;
    if (creditCardCVV.length < 3) return false;
    if (getCreditCardOwnerData().name === "") return false;
    if (getCreditCardOwnerData().cpf.length < 11) return false;
    if (getCreditCardOwnerData().phone.length < 10) return false;
    if (getCreditCardOwnerData().birth_date.length < 10) return false;

    // Validações
    if (!cnpValidation(getCreditCardOwnerData().cpf)) return false;

    return true;
  };

  useEffect(() => {
    // console.log("temos um sender_hash", invoice.invoice.general_info.pg_card.sender_hash);
    if (invoice.invoice.general_info.pg_card.sender_hash !== "") {
      fetch(`${API_BASE_URL}/invoice/init`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(invoice),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errData) => {
              throw new Error(errData.message);
            });
          }
          return response.json();
        })
        .then((data) => {
          console.log("Success:", data);
          console.log("invoice id:", data.invoice_id);
          setInvoiceID(data.invoice_id);
          setIsLoading(false);
          setPgReady(false);
          setIsSended(true);
        })
        .catch((error) => {
          console.error("Error:", error);
          setIsLoading(false);
          showError(error);
        });
    }
  }, [invoice.invoice.general_info.pg_card.sender_hash]);

  const countRef = useRef(count);

  useEffect(() => {
    // console.log("count mudou", count);
    countRef.current = count; // Atualize o ref sempre que count mudar
  }, [count]);

  useEffect(() => {
    // console.log("invoiceID mudou", invoiceID);
    const fetchInvoice = async () => {
      if (!invoiceID) return;
      if (paymentMethod !== PAY_CREDIT_CARD) return;
      if (isPayed) return;
      if (isLate) return;

      try {
        fetch(`${API_BASE_URL}/invoice/${invoiceID}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((errData) => {
                throw new Error(errData.message);
              });
            }
            return response.json();
          })
          .then((data) => {
            console.log(data);
            if (data.invoice.status === STATUS_ERROR) {
              setIsProcessedWithError(true);
              let history = data.invoice.historico; //    "historico": "ABERTA EM: 2024-04-09 10:46:31 | ERROR: credit card holder name invalid value: DWDDWDWDWD",
              let historyArr = history.split("|");
              let error = historyArr.find((element) => element.includes("ERROR"));
              if (error) {
                setErrorString(error);
              }
            }

            if (data.invoice.status === STATUS_PAID) {
              setIsPayed(true);
            }

            // console.log("count", countRef.current); // Use o ref em vez de count
            setCount((prevCount) => prevCount + 1);
          })
          .catch((error) => {
            console.error("Error:", error);
            showError(error);
          });
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchInvoice();
    const interval = setInterval(() => {
      // console.log("count", countRef.current); // Use o ref em vez de count
      if (countRef.current < 10) {
        fetchInvoice();
      } else {
        setIsLate(true);
      }
      // setCount(prevCount => prevCount + 1);
    }, 3000);

    return () => {
      clearInterval(interval);
    };

  }, [invoiceID]);

  const closeModal = () => {
    setIsLoading(false);
    setIsSended(false);
    setIsPayed(false);
    setIsProcessedWithError(false);
    setErrorString("");
    setIsLate(false);
    setCount(0);

    setPgReady(true);

    setPGCardToken("");
    setPGCardSenderHash("");

    setInvoiceID("");

    props.onHide();
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      centered
    >
      <Confetti
        run={isPayed}
        numberOfPieces={800}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: "-1",
        }}
      />
      <Modal.Header>
        <FontAwesomeIcon icon={faCreditCard} className="me-2 fs-5" />
        <Modal.Title className="w-100">Cartão de crédito</Modal.Title>
        {
          (
            isProcessedWithError &&
            // (!isLate && isProcessedWithError) &&
            !isPayed &&
            !isLoading
          )
          && (
            <Button
              variant="link"
              className="btn-close"
              onClick={closeModal}
            />
          )}
      </Modal.Header>
      <Modal.Body className="">
        {!pgReady && !isSended && !isLate && (
          <>
            <div className="text-center">
              <h5 className="mb-4">Processando...</h5>
              <div
                className="spinner-border text-success mb-4 fs-5 "
                role="status"
                style={{ width: "6rem", height: "6rem", margin: "auto" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </>
        )}
        {pgReady && !isSended && (
          <Form>
            <Form.Group className="mb-1">
              <Form.Label>Dados do cartão:</Form.Label>
            </Form.Group>
            <Form.Group className="mb-1">
              <Form.Label className="mb-0">Número do Cartão</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                placeholder="0000 0000 0000 0000"
                value={creditCardNumber}
                onChange={(e) => handleCardNumber(e.target.value)}
                disabled={isLoading}
                as={InputMask}
                mask={"9999 9999 9999 9999"}
                maskChar={""}
              />
            </Form.Group>
            <Form.Group className="mb-0">
              <Form.Label className="mb-0 mt-0">Parcelas</Form.Label>
              <Form.Select
                defaultValue={0}
                size="sm"
                onChange={(e) => {
                  setPGCardInstallmentsQuantity(e.target.value);
                  setPGCardInstallmentsValue(
                    installmentsArr[e.target.value - 1].installmentAmount,
                  );
                }}
                disabled={isLoading}
              >
                <OptionsInstallments installmentsObj={installmentsArr} />
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-0">
              <Form.Label className="mb-0 mt-0">
                Nome Impresso no Cartão
              </Form.Label>
              <Form.Control
                size="sm"
                value={getCreditCardOwnerData().name}
                type="text"
                placeholder="Nome Impresso no Cartão"
                onChange={(e) => setPGCardOwnerName(e.target.value)}
                disabled={isLoading}
              />
            </Form.Group>
            <Row>
              <Col>
                <Form.Group className="mb-0">
                  <Form.Label className="mb-0 mt-0">Venc. Mês</Form.Label>
                  <Form.Select
                    defaultValue={""}
                    size="sm"
                    onChange={(e) =>
                      setCreditCardExpirationMonth(e.target.value)
                    }
                    disabled={isLoading}
                  >
                    <option disabled value="">
                      Mês Venc.
                    </option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-0">
                  <Form.Label className="mb-0 mt-0">Venc. Ano</Form.Label>
                  <Form.Select
                    defaultValue={""}
                    size="sm"
                    onChange={(e) =>
                      setCreditCardExpirationYear(e.target.value)
                    }
                    disabled={isLoading}
                  >
                    <OptionsYearsUntilExpiration />
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-0">
                  <Form.Label className="mb-0 mt-0">CVV</Form.Label>
                  <Form.Control
                    value={creditCardCVV}
                    size="sm"
                    type="text"
                    placeholder="000"
                    onChange={(e) => setCreditCardCVV(e.target.value)}
                    disabled={isLoading}
                    as={InputMask}
                    mask={"9999"}
                    maskChar={""}
                  />
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <Form.Label className="mb-0 mt-0">Dados do Titular:</Form.Label>
            <Row>
              <Col>
                <Form.Group className="mb-0">
                  <Form.Label className="mb-0 mt-0">CPF</Form.Label>
                  <Form.Control
                    value={getCreditCardOwnerData().cpf}
                    size="sm"
                    type="text"
                    placeholder="000.000.000-00"
                    onChange={(e) => setPGCardOwnerCPF(e.target.value)}
                    disabled={isLoading}
                    as={InputMask}
                    mask={"999.999.999-99"}
                    maskChar={""}
                    isInvalid={
                      getCreditCardOwnerData().cpf.length >= 11 &&
                      !cnpValidation(getCreditCardOwnerData().cpf)
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-0">
                  <Form.Label className="mb-0 mt-0">Celular</Form.Label>
                  <Form.Control
                    value={getCreditCardOwnerData().phone}
                    size="sm"
                    type="text"
                    placeholder="(11) 9 9999-9999"
                    onChange={(e) => setPGCardOwnerPhone(e.target.value)}
                    disabled={isLoading}
                    as={InputMask}
                    mask={dinamicCelMask(getCreditCardOwnerData().phone)}
                    maskChar={""}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-0">
                  <Form.Label className="mb-0 mt-0">Data Nasc.</Form.Label>
                  <Form.Control
                    value={getCreditCardOwnerData().birth_date}
                    size="sm"
                    type="text"
                    placeholder="01/01/1980"
                    onChange={(e) => setPGCardOwnerBirthDate(e.target.value)}
                    disabled={isLoading}
                    as={InputMask}
                    mask={"99/99/9999"}
                    maskChar={""}
                  />
                </Form.Group>
              </Col>
            </Row>
            <ButtonNext
              variant="success"
              text="Pagar"
              className="float-end mt-4"
              isLoading={isLoading}
              faicon={faCreditCardAlt}
              disabled={!canDoPayment()}
              onClick={(e) => {
                sendPayment(e);
              }}
            />
          </Form>
        )}
        {isSended && !isProcessedWithError && !isPayed && !isLate && (
          <div className="text-center">
            <h4>O seu pagamento foi enviado com sucesso!</h4>
            <div
              className="spinner-border text-success mb-5 fs-5 mt-5"
              role="status"
              style={{ width: "6rem", height: "6rem", margin: "auto" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted fw-semibold fs-5">
              Vamos aguardar a confirmação do pagamento pelo PagSeguro.
            </p>
          </div>
        )}
        {isSended && isProcessedWithError && !isPayed && (
          <div className="text-center">
            <h4 className="mb-5">
              <FontAwesomeIcon icon={faWarning} color="#d9534f" className="me-2" />
              Ocorreu um erro ao processar o pagamento:
            </h4>
            <p className="text-muted fw-semibold fs-5">
              {errorString}
            </p>
          </div>
        )}
        {isPayed && (
          <div className="text-center">
            <h4 className="mb-2">Pagamento efetuado com sucesso!</h4>
            <p>Obrigado por utilizar os nossos sistemas.</p>
            <Lottie
              animationData={animationPayed}
              style={{ width: "300px", margin: "auto" }}
            />
            <p className="text-muted mb-1">
              <small>
                <FontAwesomeIcon
                  icon={faWarning}
                  className="me-2"
                  color="#dc3445"
                />
                <strong> Atenção:</strong> Sua licença e nota fiscal será
                enviada para o seu e-mail cadastrado.
              </small>
            </p>
            <Button
              variant="outline-success"
              className="mt-2"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "https://shoficina.com.br";
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ transform: "rotate(180deg)" }}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="ms-2 " />
                </div>
                Voltar para o site
              </div>
            </Button>
          </div>
        )}
        {!isPayed && !isProcessedWithError && isLate && (
          <div className="text-center">
            <h4>Ops... Está demorando mais que o esperado!</h4>
            <p className="mb-0">
              Estamos aguardando a confirmação do PagSeguro.<br />
              Você pode fechar essa janela e aguardar nosso e-mail de confirmação.<br />
              Isso pode demorar de 1 a 2 horas para ser concluída.
            </p>
            <Lottie
              animationData={animationLate}
              style={{ width: "300px", margin: "auto" }}
            />
            <span>
              Em caso de dúvidas, entre em contato com nosso time comercial.<br />
            </span>
            <Button
              variant="outline-success"
              className="mt-2"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "https://shoficina.com.br";
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ transform: "rotate(180deg)" }}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="ms-2 " />
                </div>
                Voltar para o site
              </div>
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalPayWithCreditCard;
